<template>
    <v-card
        v-if="inspection"
        class   = "w-100"
        :ripple = "false"
        flat
        rounded
    >
        <div class="v-flex">
            <div class="inspection-elevator-no">
                {{ inspection.elevatorNo}}
            </div>
            <v-spacer />
            <div class="doc-created" :class="inspection.printed ? 'primary white--text' : 'white'">
                {{ created}}
            </div>
            <div style="margin-top: -1px; width: 25px">
                <v-icon
                    v-if   = "inspection.conditionId"
                    size   = "20"
                >
                    mdi-elevator
                </v-icon>
            </div>
            <div class="ml-2 mr-1" style="width: 25px;">
                <v-icon
                    v-if   = "inspection.auditId"
                    size="20"
                >
                    mdi-clipboard-check-outline
                </v-icon>
            </div>

            <div class="ml-2 mr-1">
                <v-tooltip bottom >
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            @click = "onDocument"
                            v-bind = "attrs"
                            v-on   = "on"
                        >
                            <v-icon size="20" color="primary">mdi-printer</v-icon>
                        </a>
                    </template>
                    <span>Dokumente erstellen</span>
                </v-tooltip>
            </div>
        </div>
        <div class = "inspection-address">
            {{ inspection.zip}} {{ inspection.city}}, {{ inspection.street}}
        </div>
    </v-card>
</template>

<script>
import Core from "@/modules/core/service/Core";

export default {
    name: "PInspectionReportCard",

    props: {
        inspection: {

        }
    },

    computed: {
        created () {
            if (!this.inspection || !this.inspection.created) {
                return null;
            }

            return Core.format.date.display(this.inspection.created);
        }
    },

    methods: {
        onDocument () {
            this.$emit("print", this.inspection)
        }
    }
}
</script>

<style scoped>

.inspection-elevator-no {
    font-size: 14px;
    font-weight: bold;
}

.inspection-address {
    font-size: 12px;
    line-height: 14px;
}

.doc-created {
    font-size: 10pt;
    margin-right: 8px;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 4px;
    margin-top: 1px;
}
</style>